import { render, staticRenderFns } from "./PatientChatbox.vue?vue&type=template&id=0ee66766&scoped=true"
import script from "./PatientChatbox.vue?vue&type=script&lang=js"
export * from "./PatientChatbox.vue?vue&type=script&lang=js"
import style0 from "./PatientChatbox.vue?vue&type=style&index=0&id=0ee66766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee66766",
  null
  
)

export default component.exports